import { oz } from '@weft/utils';

export const INTEGRATION_SYNC_DIRECTION = Object.freeze({
  from: 'from',
  to: 'to',
});

export const IntegrationSyncDirectionSchema = oz.nativeEnum(INTEGRATION_SYNC_DIRECTION);

export type IntegrationSyncDirection = oz.infer<typeof IntegrationSyncDirectionSchema>;